import { ReadResult, WriteOptions } from '@capacitor/clipboard';
import { createContext, useContext } from 'react';

export interface ClipboardContextType {
  writeToClipboard: (writeOptions: WriteOptions) => Promise<void>;
  readFromClipboard: () => Promise<ReadResult>;
}

export const ClipboardContext = createContext<ClipboardContextType | null>(null);

export const useClipboardContext = () => useContext(ClipboardContext) as ClipboardContextType;
